// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/dataplanejobqueue.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import type { KubernetesResourceQuotaData } from "../../kubernetes/v1/resourcequota_pb";
import { file_chalk_kubernetes_v1_resourcequota } from "../../kubernetes/v1/resourcequota_pb";
import type { KubernetesScaledObjectData } from "../../kubernetes/v1/scaledobject_pb";
import { file_chalk_kubernetes_v1_scaledobject } from "../../kubernetes/v1/scaledobject_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/dataplanejobqueue.proto.
 */
export const file_chalk_server_v1_dataplanejobqueue: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_auth_v1_permissions, file_chalk_kubernetes_v1_resourcequota, file_chalk_kubernetes_v1_scaledobject, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.server.v1.JobQueueItem
 */
export type JobQueueItem = Message<"chalk.server.v1.JobQueueItem"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string environment_id = 3;
   */
  environmentId: string;

  /**
   * @generated from field: string deployment_id = 4;
   */
  deploymentId: string;

  /**
   * @generated from field: optional string job_name = 5;
   */
  jobName?: string;

  /**
   * @generated from field: int64 attempt_idx = 6;
   */
  attemptIdx: bigint;

  /**
   * @generated from field: chalk.server.v1.JobQueueState state = 7;
   */
  state: JobQueueState;

  /**
   * @generated from field: optional google.protobuf.Timestamp scheduled_at = 8;
   */
  scheduledAt?: Timestamp;

  /**
   * @generated from field: chalk.server.v1.JobQueueKind kind = 9;
   */
  kind: JobQueueKind;

  /**
   * @generated from field: bytes job_args = 10;
   */
  jobArgs: Uint8Array;

  /**
   * @generated from field: string resource_group = 11;
   */
  resourceGroup: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp finalized_at = 12;
   */
  finalizedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_attempted_at = 13;
   */
  lastAttemptedAt?: Timestamp;

  /**
   * @generated from field: repeated string attempted_by = 14;
   */
  attemptedBy: string[];

  /**
   * @generated from field: optional google.protobuf.Timestamp last_heartbeat_at = 15;
   */
  lastHeartbeatAt?: Timestamp;

  /**
   * @generated from field: optional string operation_id = 16;
   */
  operationId?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp cancelation_requested_at = 17;
   */
  cancelationRequestedAt?: Timestamp;

  /**
   * @generated from field: int64 max_attempts = 18;
   */
  maxAttempts: bigint;

  /**
   * @generated from field: string mainline_deployment_id = 19;
   */
  mainlineDeploymentId: string;

  /**
   * @generated from field: optional int64 shard_id = 20 [deprecated = true];
   * @deprecated
   */
  shardId?: bigint;

  /**
   * @generated from field: optional int64 job_index = 21;
   */
  jobIndex?: bigint;

  /**
   * @generated from field: optional int64 fetch_priority = 22;
   */
  fetchPriority?: bigint;

  /**
   * @generated from field: optional string workflow_execution_id = 23;
   */
  workflowExecutionId?: string;
};

/**
 * Describes the message chalk.server.v1.JobQueueItem.
 * Use `create(JobQueueItemSchema)` to create a new message.
 */
export const JobQueueItemSchema: GenMessage<JobQueueItem> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 0);

/**
 * @generated from message chalk.server.v1.GetDataPlaneJobQueueRequest
 */
export type GetDataPlaneJobQueueRequest = Message<"chalk.server.v1.GetDataPlaneJobQueueRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message chalk.server.v1.GetDataPlaneJobQueueRequest.
 * Use `create(GetDataPlaneJobQueueRequestSchema)` to create a new message.
 */
export const GetDataPlaneJobQueueRequestSchema: GenMessage<GetDataPlaneJobQueueRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 1);

/**
 * @generated from message chalk.server.v1.GetDataPlaneJobQueueResponse
 */
export type GetDataPlaneJobQueueResponse = Message<"chalk.server.v1.GetDataPlaneJobQueueResponse"> & {
  /**
   * @generated from field: chalk.server.v1.JobQueueItem job = 1;
   */
  job?: JobQueueItem;
};

/**
 * Describes the message chalk.server.v1.GetDataPlaneJobQueueResponse.
 * Use `create(GetDataPlaneJobQueueResponseSchema)` to create a new message.
 */
export const GetDataPlaneJobQueueResponseSchema: GenMessage<GetDataPlaneJobQueueResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 2);

/**
 * @generated from message chalk.server.v1.ListDataPlaneJobQueueRequest
 */
export type ListDataPlaneJobQueueRequest = Message<"chalk.server.v1.ListDataPlaneJobQueueRequest"> & {
  /**
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * @generated from field: string deployment_id = 2;
   */
  deploymentId: string;

  /**
   * @generated from field: chalk.server.v1.JobQueueState state = 3;
   */
  state: JobQueueState;

  /**
   * @generated from field: chalk.server.v1.JobQueueKind kind = 4;
   */
  kind: JobQueueKind;

  /**
   * @generated from field: int32 limit = 5;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 6;
   */
  offset: number;

  /**
   * @generated from field: string operation_id = 7;
   */
  operationId: string;

  /**
   * @generated from field: string resource_group = 8;
   */
  resourceGroup: string;
};

/**
 * Describes the message chalk.server.v1.ListDataPlaneJobQueueRequest.
 * Use `create(ListDataPlaneJobQueueRequestSchema)` to create a new message.
 */
export const ListDataPlaneJobQueueRequestSchema: GenMessage<ListDataPlaneJobQueueRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 3);

/**
 * @generated from message chalk.server.v1.ListDataPlaneJobQueueResponse
 */
export type ListDataPlaneJobQueueResponse = Message<"chalk.server.v1.ListDataPlaneJobQueueResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.JobQueueItem jobs = 1;
   */
  jobs: JobQueueItem[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message chalk.server.v1.ListDataPlaneJobQueueResponse.
 * Use `create(ListDataPlaneJobQueueResponseSchema)` to create a new message.
 */
export const ListDataPlaneJobQueueResponseSchema: GenMessage<ListDataPlaneJobQueueResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 4);

/**
 * @generated from message chalk.server.v1.GetJobQueueAuxiliaryResourcesRequest
 */
export type GetJobQueueAuxiliaryResourcesRequest = Message<"chalk.server.v1.GetJobQueueAuxiliaryResourcesRequest"> & {
  /**
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * @generated from field: string resource_group = 2;
   */
  resourceGroup: string;
};

/**
 * Describes the message chalk.server.v1.GetJobQueueAuxiliaryResourcesRequest.
 * Use `create(GetJobQueueAuxiliaryResourcesRequestSchema)` to create a new message.
 */
export const GetJobQueueAuxiliaryResourcesRequestSchema: GenMessage<GetJobQueueAuxiliaryResourcesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 5);

/**
 * @generated from message chalk.server.v1.GetJobQueueAuxiliaryResourcesResponse
 */
export type GetJobQueueAuxiliaryResourcesResponse = Message<"chalk.server.v1.GetJobQueueAuxiliaryResourcesResponse"> & {
  /**
   * @generated from field: map<string, chalk.kubernetes.v1.KubernetesScaledObjectData> deployment_scaled_objects = 1;
   */
  deploymentScaledObjects: { [key: string]: KubernetesScaledObjectData };

  /**
   * @generated from field: chalk.kubernetes.v1.KubernetesResourceQuotaData resource_quota = 2;
   */
  resourceQuota?: KubernetesResourceQuotaData;
};

/**
 * Describes the message chalk.server.v1.GetJobQueueAuxiliaryResourcesResponse.
 * Use `create(GetJobQueueAuxiliaryResourcesResponseSchema)` to create a new message.
 */
export const GetJobQueueAuxiliaryResourcesResponseSchema: GenMessage<GetJobQueueAuxiliaryResourcesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 6);

/**
 * @generated from message chalk.server.v1.ExplainOperationProgressRequest
 */
export type ExplainOperationProgressRequest = Message<"chalk.server.v1.ExplainOperationProgressRequest"> & {
  /**
   * @generated from field: string operation_id = 1;
   */
  operationId: string;
};

/**
 * Describes the message chalk.server.v1.ExplainOperationProgressRequest.
 * Use `create(ExplainOperationProgressRequestSchema)` to create a new message.
 */
export const ExplainOperationProgressRequestSchema: GenMessage<ExplainOperationProgressRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 7);

/**
 * @generated from message chalk.server.v1.ExplainOperationProgressResponse
 */
export type ExplainOperationProgressResponse = Message<"chalk.server.v1.ExplainOperationProgressResponse"> & {
  /**
   * @generated from field: int32 max_num_consumers_in_resource_group = 1;
   */
  maxNumConsumersInResourceGroup: number;

  /**
   * @generated from field: optional int32 max_num_consumers_for_operation = 2;
   */
  maxNumConsumersForOperation?: number;

  /**
   * @generated from field: int32 num_running_consumers_for_operation = 3;
   */
  numRunningConsumersForOperation: number;

  /**
   * @generated from field: int32 num_running_consumers_in_resource_group = 4;
   */
  numRunningConsumersInResourceGroup: number;

  /**
   * @generated from field: int32 num_pending_consumers_in_resource_group = 5;
   */
  numPendingConsumersInResourceGroup: number;

  /**
   * @generated from field: optional int32 operation_depth_in_job_queue = 6;
   */
  operationDepthInJobQueue?: number;
};

/**
 * Describes the message chalk.server.v1.ExplainOperationProgressResponse.
 * Use `create(ExplainOperationProgressResponseSchema)` to create a new message.
 */
export const ExplainOperationProgressResponseSchema: GenMessage<ExplainOperationProgressResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 8);

/**
 * @generated from message chalk.server.v1.JobQueueRowSummary
 */
export type JobQueueRowSummary = Message<"chalk.server.v1.JobQueueRowSummary"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: int32 attempt_idx = 6;
   */
  attemptIdx: number;

  /**
   * @generated from field: chalk.server.v1.JobQueueState state = 7;
   */
  state: JobQueueState;

  /**
   * @generated from field: optional google.protobuf.Timestamp finalized_at = 12;
   */
  finalizedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_attempted_at = 13;
   */
  lastAttemptedAt?: Timestamp;

  /**
   * reference against `attempters` in `JobQueueOperationSummary`
   *
   * @generated from field: repeated int32 attempter_idxs = 14;
   */
  attempterIdxs: number[];

  /**
   * @generated from field: optional google.protobuf.Timestamp last_heartbeat_at = 15;
   */
  lastHeartbeatAt?: Timestamp;

  /**
   * @generated from field: int32 max_attempts = 18;
   */
  maxAttempts: number;

  /**
   * nullable in table but not optional for job queue offline queries
   *
   * @generated from field: optional int32 job_idx = 21;
   */
  jobIdx?: number;
};

/**
 * Describes the message chalk.server.v1.JobQueueRowSummary.
 * Use `create(JobQueueRowSummarySchema)` to create a new message.
 */
export const JobQueueRowSummarySchema: GenMessage<JobQueueRowSummary> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 9);

/**
 * @generated from message chalk.server.v1.JobQueueOperationSummary
 */
export type JobQueueOperationSummary = Message<"chalk.server.v1.JobQueueOperationSummary"> & {
  /**
   * Rows with job index, which are also the corresponding keys.
   *
   * @generated from field: map<int32, chalk.server.v1.JobQueueRowSummary> indexed_row_summaries = 1;
   */
  indexedRowSummaries: { [key: number]: JobQueueRowSummary };

  /**
   * @generated from field: string resource_group_name = 3;
   */
  resourceGroupName: string;

  /**
   * @generated from field: string mainline_deployment_id = 4;
   */
  mainlineDeploymentId: string;

  /**
   * @generated from field: chalk.server.v1.JobQueueKind kind = 5;
   */
  kind: JobQueueKind;

  /**
   * @generated from field: repeated string attempters = 6;
   */
  attempters: string[];

  /**
   * @generated from field: optional string workflow_execution_id = 7;
   */
  workflowExecutionId?: string;

  /**
   * @generated from field: repeated string unsatisfied_dependency_operation_ids = 8;
   */
  unsatisfiedDependencyOperationIds: string[];

  /**
   * @generated from field: optional int32 num_workers = 9;
   */
  numWorkers?: number;
};

/**
 * Describes the message chalk.server.v1.JobQueueOperationSummary.
 * Use `create(JobQueueOperationSummarySchema)` to create a new message.
 */
export const JobQueueOperationSummarySchema: GenMessage<JobQueueOperationSummary> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 10);

/**
 * @generated from message chalk.server.v1.GetJobQueueOperationSummaryRequest
 */
export type GetJobQueueOperationSummaryRequest = Message<"chalk.server.v1.GetJobQueueOperationSummaryRequest"> & {
  /**
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * @generated from field: string operation_id = 2;
   */
  operationId: string;

  /**
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;

  /**
   * @generated from field: optional int32 offset = 4;
   */
  offset?: number;
};

/**
 * Describes the message chalk.server.v1.GetJobQueueOperationSummaryRequest.
 * Use `create(GetJobQueueOperationSummaryRequestSchema)` to create a new message.
 */
export const GetJobQueueOperationSummaryRequestSchema: GenMessage<GetJobQueueOperationSummaryRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 11);

/**
 * @generated from message chalk.server.v1.GetJobQueueOperationSummaryResponse
 */
export type GetJobQueueOperationSummaryResponse = Message<"chalk.server.v1.GetJobQueueOperationSummaryResponse"> & {
  /**
   * let's be explicit about this
   *
   * @generated from field: bool managed_by_job_queue = 2;
   */
  managedByJobQueue: boolean;

  /**
   * If not present, there is no job queue data
   * If the query is already in the offline_queries table, it doesn't need to be refetched if the summary is missing.
   * Barring a bizarre race, a job-queue offline query is recorded in job_queue before offline_queries.
   *
   * @generated from field: optional chalk.server.v1.JobQueueOperationSummary summary = 1;
   */
  summary?: JobQueueOperationSummary;

  /**
   * possible even if there is no data
   *
   * @generated from field: optional string referencing_workflow_execution_id = 3;
   */
  referencingWorkflowExecutionId?: string;
};

/**
 * Describes the message chalk.server.v1.GetJobQueueOperationSummaryResponse.
 * Use `create(GetJobQueueOperationSummaryResponseSchema)` to create a new message.
 */
export const GetJobQueueOperationSummaryResponseSchema: GenMessage<GetJobQueueOperationSummaryResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 12);

/**
 * @generated from message chalk.server.v1.JobQueueAttempt
 */
export type JobQueueAttempt = Message<"chalk.server.v1.JobQueueAttempt"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string environment_id = 3;
   */
  environmentId: string;

  /**
   * @generated from field: string deployment_id = 4;
   */
  deploymentId: string;

  /**
   * @generated from field: int32 job_queue_id = 5;
   */
  jobQueueId: number;

  /**
   * @generated from field: int64 attempt_idx = 6;
   */
  attemptIdx: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp queued_at = 7;
   */
  queuedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp started_at = 8;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: optional string attempted_by = 9;
   */
  attemptedBy?: string;

  /**
   * @generated from field: int32 state = 10;
   */
  state: number;

  /**
   * @generated from field: optional google.protobuf.Timestamp finished_at = 11;
   */
  finishedAt?: Timestamp;
};

/**
 * Describes the message chalk.server.v1.JobQueueAttempt.
 * Use `create(JobQueueAttemptSchema)` to create a new message.
 */
export const JobQueueAttemptSchema: GenMessage<JobQueueAttempt> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 13);

/**
 * @generated from message chalk.server.v1.ListJobQueueAttemptsRequest
 */
export type ListJobQueueAttemptsRequest = Message<"chalk.server.v1.ListJobQueueAttemptsRequest"> & {
  /**
   * @generated from field: optional int32 job_queue_id = 1;
   */
  jobQueueId?: number;

  /**
   * @generated from field: optional string operation_id = 3;
   */
  operationId?: string;
};

/**
 * Describes the message chalk.server.v1.ListJobQueueAttemptsRequest.
 * Use `create(ListJobQueueAttemptsRequestSchema)` to create a new message.
 */
export const ListJobQueueAttemptsRequestSchema: GenMessage<ListJobQueueAttemptsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 14);

/**
 * @generated from message chalk.server.v1.ListJobQueueAttemptsResponse
 */
export type ListJobQueueAttemptsResponse = Message<"chalk.server.v1.ListJobQueueAttemptsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.JobQueueAttempt attempts = 1;
   */
  attempts: JobQueueAttempt[];
};

/**
 * Describes the message chalk.server.v1.ListJobQueueAttemptsResponse.
 * Use `create(ListJobQueueAttemptsResponseSchema)` to create a new message.
 */
export const ListJobQueueAttemptsResponseSchema: GenMessage<ListJobQueueAttemptsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 15);

/**
 * @generated from message chalk.server.v1.OperationAndShard
 */
export type OperationAndShard = Message<"chalk.server.v1.OperationAndShard"> & {
  /**
   * @generated from field: string operation_id = 1;
   */
  operationId: string;

  /**
   * @generated from field: int64 shard_id = 2;
   */
  shardId: bigint;
};

/**
 * Describes the message chalk.server.v1.OperationAndShard.
 * Use `create(OperationAndShardSchema)` to create a new message.
 */
export const OperationAndShardSchema: GenMessage<OperationAndShard> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 16);

/**
 * Kubernetes-style resource strings (e.g. "2", "500m", "4Gi") representing the
 * sum of container resource requests for a consumer pod. Mirrors the JSON payload
 * stored in job_queue_consumers.pod_requests.
 *
 * @generated from message chalk.server.v1.JobQueueConsumerResourceRequests
 */
export type JobQueueConsumerResourceRequests = Message<"chalk.server.v1.JobQueueConsumerResourceRequests"> & {
  /**
   * @generated from field: optional string cpu = 1;
   */
  cpu?: string;

  /**
   * @generated from field: optional string memory = 2;
   */
  memory?: string;

  /**
   * @generated from field: optional string ephemeral_storage = 3;
   */
  ephemeralStorage?: string;

  /**
   * @generated from field: optional string ephemeral_volume_size = 4;
   */
  ephemeralVolumeSize?: string;
};

/**
 * Describes the message chalk.server.v1.JobQueueConsumerResourceRequests.
 * Use `create(JobQueueConsumerResourceRequestsSchema)` to create a new message.
 */
export const JobQueueConsumerResourceRequestsSchema: GenMessage<JobQueueConsumerResourceRequests> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 17);

/**
 * Description of the node a consumer pod is scheduled onto. Mirrors the JSON
 * payload stored in job_queue_consumers.node_spec.
 *
 * @generated from message chalk.server.v1.JobQueueConsumerNodeSpec
 */
export type JobQueueConsumerNodeSpec = Message<"chalk.server.v1.JobQueueConsumerNodeSpec"> & {
  /**
   * @generated from field: optional string cpu = 1;
   */
  cpu?: string;

  /**
   * @generated from field: optional string memory = 2;
   */
  memory?: string;

  /**
   * @generated from field: optional string instance_type = 3;
   */
  instanceType?: string;
};

/**
 * Describes the message chalk.server.v1.JobQueueConsumerNodeSpec.
 * Use `create(JobQueueConsumerNodeSpecSchema)` to create a new message.
 */
export const JobQueueConsumerNodeSpecSchema: GenMessage<JobQueueConsumerNodeSpec> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 18);

/**
 * A row in the job_queue_consumers Timescale table. Represents the observed
 * lifetime of a single offline-query-consumer pod scheduled into a resource group.
 *
 * @generated from message chalk.server.v1.JobQueueConsumer
 */
export type JobQueueConsumer = Message<"chalk.server.v1.JobQueueConsumer"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string environment_id = 2;
   */
  environmentId: string;

  /**
   * @generated from field: string deployment_id = 3;
   */
  deploymentId: string;

  /**
   * @generated from field: string pod_name = 4;
   */
  podName: string;

  /**
   * @generated from field: optional string resource_group = 5;
   */
  resourceGroup?: string;

  /**
   * @generated from field: optional string kube_cluster_name = 6;
   */
  kubeClusterName?: string;

  /**
   * @generated from field: optional string node_name = 7;
   */
  nodeName?: string;

  /**
   * @generated from field: optional string instance_id = 8;
   */
  instanceId?: string;

  /**
   * @generated from field: optional chalk.server.v1.JobQueueConsumerResourceRequests pod_requests = 9;
   */
  podRequests?: JobQueueConsumerResourceRequests;

  /**
   * @generated from field: optional chalk.server.v1.JobQueueConsumerNodeSpec node_spec = 10;
   */
  nodeSpec?: JobQueueConsumerNodeSpec;

  /**
   * @generated from field: optional string instance_type = 11;
   */
  instanceType?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp terminated_at = 13;
   */
  terminatedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp scheduled_at = 14;
   */
  scheduledAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp container_started_at = 15;
   */
  containerStartedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp first_ready_at = 16;
   */
  firstReadyAt?: Timestamp;

  /**
   * @generated from field: optional int32 container_restart_count = 17;
   */
  containerRestartCount?: number;
};

/**
 * Describes the message chalk.server.v1.JobQueueConsumer.
 * Use `create(JobQueueConsumerSchema)` to create a new message.
 */
export const JobQueueConsumerSchema: GenMessage<JobQueueConsumer> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 19);

/**
 * @generated from message chalk.server.v1.ListJobQueueConsumersRequest
 */
export type ListJobQueueConsumersRequest = Message<"chalk.server.v1.ListJobQueueConsumersRequest"> & {
  /**
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * If unset, returns consumers from any resource group. The "default" resource
   * group can be addressed by any of the strings "", "default", or
   * "default_resource_group" (and matches consumers whose resource_group column
   * is NULL).
   *
   * @generated from field: optional string resource_group = 2;
   */
  resourceGroup?: string;

  /**
   * If false (the default), only currently-active consumers (terminated_at IS NULL)
   * are returned.
   *
   * @generated from field: bool include_terminated = 3;
   */
  includeTerminated: boolean;

  /**
   * Max rows to return. Defaults to 200 if unset or 0.
   *
   * @generated from field: optional int32 limit = 4;
   */
  limit?: number;
};

/**
 * Describes the message chalk.server.v1.ListJobQueueConsumersRequest.
 * Use `create(ListJobQueueConsumersRequestSchema)` to create a new message.
 */
export const ListJobQueueConsumersRequestSchema: GenMessage<ListJobQueueConsumersRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 20);

/**
 * @generated from message chalk.server.v1.ListJobQueueConsumersResponse
 */
export type ListJobQueueConsumersResponse = Message<"chalk.server.v1.ListJobQueueConsumersResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.JobQueueConsumer consumers = 1;
   */
  consumers: JobQueueConsumer[];
};

/**
 * Describes the message chalk.server.v1.ListJobQueueConsumersResponse.
 * Use `create(ListJobQueueConsumersResponseSchema)` to create a new message.
 */
export const ListJobQueueConsumersResponseSchema: GenMessage<ListJobQueueConsumersResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 21);

/**
 * One job attempt that ran on a particular consumer pod, joined with the
 * job_queue row it belongs to. `started_at`/`finished_at` bound the interval the
 * consumer spent on this attempt.
 *
 * @generated from message chalk.server.v1.JobQueueConsumerWorkload
 */
export type JobQueueConsumerWorkload = Message<"chalk.server.v1.JobQueueConsumerWorkload"> & {
  /**
   * @generated from field: int32 attempt_id = 1;
   */
  attemptId: number;

  /**
   * @generated from field: int32 job_queue_id = 2;
   */
  jobQueueId: number;

  /**
   * @generated from field: int64 attempt_idx = 3;
   */
  attemptIdx: bigint;

  /**
   * @generated from field: chalk.server.v1.JobQueueState attempt_state = 4;
   */
  attemptState: JobQueueState;

  /**
   * Job-level fields are absent when the parent job_queue row has been archived
   * out from under a still-retained attempt row.
   *
   * @generated from field: optional chalk.server.v1.JobQueueState job_state = 5;
   */
  jobState?: JobQueueState;

  /**
   * @generated from field: optional chalk.server.v1.JobQueueKind job_kind = 6;
   */
  jobKind?: JobQueueKind;

  /**
   * @generated from field: optional string operation_id = 7;
   */
  operationId?: string;

  /**
   * @generated from field: optional string job_name = 8;
   */
  jobName?: string;

  /**
   * @generated from field: optional int64 job_index = 9;
   */
  jobIndex?: bigint;

  /**
   * @generated from field: optional string resource_group = 10;
   */
  resourceGroup?: string;

  /**
   * @generated from field: google.protobuf.Timestamp queued_at = 11;
   */
  queuedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp started_at = 12;
   */
  startedAt?: Timestamp;

  /**
   * When the worker began the work proper, after setup.
   *
   * @generated from field: optional google.protobuf.Timestamp work_started_at = 13;
   */
  workStartedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp finished_at = 14;
   */
  finishedAt?: Timestamp;
};

/**
 * Describes the message chalk.server.v1.JobQueueConsumerWorkload.
 * Use `create(JobQueueConsumerWorkloadSchema)` to create a new message.
 */
export const JobQueueConsumerWorkloadSchema: GenMessage<JobQueueConsumerWorkload> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 22);

/**
 * How much of a consumer's observed lifetime it spent running work.
 *
 * `busy_seconds` is the measure of the *union* of the attempt intervals, not
 * their sum: a consumer that runs several jobs concurrently is no more than 100%
 * utilized by this definition. Attempt intervals are clipped to
 * [window_start, window_end] before merging.
 *
 * @generated from message chalk.server.v1.JobQueueConsumerUtilization
 */
export type JobQueueConsumerUtilization = Message<"chalk.server.v1.JobQueueConsumerUtilization"> & {
  /**
   * Consumer lifetime: created_at, and terminated_at or now for a live consumer.
   *
   * @generated from field: google.protobuf.Timestamp window_start = 1;
   */
  windowStart?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp window_end = 2;
   */
  windowEnd?: Timestamp;

  /**
   * @generated from field: double lifetime_seconds = 3;
   */
  lifetimeSeconds: number;

  /**
   * @generated from field: double busy_seconds = 4;
   */
  busySeconds: number;

  /**
   * @generated from field: double idle_seconds = 5;
   */
  idleSeconds: number;

  /**
   * busy_seconds / lifetime_seconds, in [0, 1]. Zero when lifetime is zero.
   *
   * @generated from field: double utilization_ratio = 6;
   */
  utilizationRatio: number;

  /**
   * @generated from field: int32 workload_count = 7;
   */
  workloadCount: number;

  /**
   * Set when the workload list was truncated by `limit`, meaning the utilization
   * figures cover only the returned workloads and understate the true busy time.
   *
   * @generated from field: bool partial = 8;
   */
  partial: boolean;
};

/**
 * Describes the message chalk.server.v1.JobQueueConsumerUtilization.
 * Use `create(JobQueueConsumerUtilizationSchema)` to create a new message.
 */
export const JobQueueConsumerUtilizationSchema: GenMessage<JobQueueConsumerUtilization> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 23);

/**
 * @generated from message chalk.server.v1.GetJobQueueConsumerTimelineRequest
 */
export type GetJobQueueConsumerTimelineRequest = Message<"chalk.server.v1.GetJobQueueConsumerTimelineRequest"> & {
  /**
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * job_queue_consumers.id, as returned by ListJobQueueConsumers.
   *
   * @generated from field: int64 consumer_id = 2;
   */
  consumerId: bigint;

  /**
   * Max workloads to return, most recently started first. Defaults to 500 if
   * unset or 0.
   *
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;
};

/**
 * Describes the message chalk.server.v1.GetJobQueueConsumerTimelineRequest.
 * Use `create(GetJobQueueConsumerTimelineRequestSchema)` to create a new message.
 */
export const GetJobQueueConsumerTimelineRequestSchema: GenMessage<GetJobQueueConsumerTimelineRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 24);

/**
 * @generated from message chalk.server.v1.GetJobQueueConsumerTimelineResponse
 */
export type GetJobQueueConsumerTimelineResponse = Message<"chalk.server.v1.GetJobQueueConsumerTimelineResponse"> & {
  /**
   * @generated from field: chalk.server.v1.JobQueueConsumer consumer = 1;
   */
  consumer?: JobQueueConsumer;

  /**
   * Ordered by started_at ascending.
   *
   * @generated from field: repeated chalk.server.v1.JobQueueConsumerWorkload workloads = 2;
   */
  workloads: JobQueueConsumerWorkload[];

  /**
   * @generated from field: chalk.server.v1.JobQueueConsumerUtilization utilization = 3;
   */
  utilization?: JobQueueConsumerUtilization;

  /**
   * @generated from field: bool truncated = 4;
   */
  truncated: boolean;
};

/**
 * Describes the message chalk.server.v1.GetJobQueueConsumerTimelineResponse.
 * Use `create(GetJobQueueConsumerTimelineResponseSchema)` to create a new message.
 */
export const GetJobQueueConsumerTimelineResponseSchema: GenMessage<GetJobQueueConsumerTimelineResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 25);

/**
 * @generated from message chalk.server.v1.ForceCancelJobQueueJobRequest
 */
export type ForceCancelJobQueueJobRequest = Message<"chalk.server.v1.ForceCancelJobQueueJobRequest"> & {
  /**
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * @generated from field: optional int32 by_job_queue_id = 2;
   */
  byJobQueueId?: number;

  /**
   * @generated from field: optional chalk.server.v1.OperationAndShard by_operation_and_shard = 3;
   */
  byOperationAndShard?: OperationAndShard;
};

/**
 * Describes the message chalk.server.v1.ForceCancelJobQueueJobRequest.
 * Use `create(ForceCancelJobQueueJobRequestSchema)` to create a new message.
 */
export const ForceCancelJobQueueJobRequestSchema: GenMessage<ForceCancelJobQueueJobRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 26);

/**
 * @generated from message chalk.server.v1.ForceCancelJobQueueJobResponse
 */
export type ForceCancelJobQueueJobResponse = Message<"chalk.server.v1.ForceCancelJobQueueJobResponse"> & {
};

/**
 * Describes the message chalk.server.v1.ForceCancelJobQueueJobResponse.
 * Use `create(ForceCancelJobQueueJobResponseSchema)` to create a new message.
 */
export const ForceCancelJobQueueJobResponseSchema: GenMessage<ForceCancelJobQueueJobResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 27);

/**
 * @generated from message chalk.server.v1.ForceCancelJobQueueJobsRequest
 */
export type ForceCancelJobQueueJobsRequest = Message<"chalk.server.v1.ForceCancelJobQueueJobsRequest"> & {
  /**
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * @generated from field: repeated int32 job_queue_ids = 2;
   */
  jobQueueIds: number[];
};

/**
 * Describes the message chalk.server.v1.ForceCancelJobQueueJobsRequest.
 * Use `create(ForceCancelJobQueueJobsRequestSchema)` to create a new message.
 */
export const ForceCancelJobQueueJobsRequestSchema: GenMessage<ForceCancelJobQueueJobsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 28);

/**
 * @generated from message chalk.server.v1.ForceCancelJobQueueJobResult
 */
export type ForceCancelJobQueueJobResult = Message<"chalk.server.v1.ForceCancelJobQueueJobResult"> & {
  /**
   * @generated from field: int32 job_queue_id = 1;
   */
  jobQueueId: number;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;

  /**
   * @generated from field: optional string error = 3;
   */
  error?: string;
};

/**
 * Describes the message chalk.server.v1.ForceCancelJobQueueJobResult.
 * Use `create(ForceCancelJobQueueJobResultSchema)` to create a new message.
 */
export const ForceCancelJobQueueJobResultSchema: GenMessage<ForceCancelJobQueueJobResult> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 29);

/**
 * @generated from message chalk.server.v1.ForceCancelJobQueueJobsResponse
 */
export type ForceCancelJobQueueJobsResponse = Message<"chalk.server.v1.ForceCancelJobQueueJobsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.ForceCancelJobQueueJobResult results = 1;
   */
  results: ForceCancelJobQueueJobResult[];
};

/**
 * Describes the message chalk.server.v1.ForceCancelJobQueueJobsResponse.
 * Use `create(ForceCancelJobQueueJobsResponseSchema)` to create a new message.
 */
export const ForceCancelJobQueueJobsResponseSchema: GenMessage<ForceCancelJobQueueJobsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 30);

/**
 * @generated from message chalk.server.v1.CancelWorkflowExecutionRequest
 */
export type CancelWorkflowExecutionRequest = Message<"chalk.server.v1.CancelWorkflowExecutionRequest"> & {
  /**
   * @generated from oneof chalk.server.v1.CancelWorkflowExecutionRequest.method
   */
  method: {
    /**
     * @generated from field: string workflow_execution_id = 1;
     */
    value: string;
    case: "workflowExecutionId";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.server.v1.CancelWorkflowExecutionRequest.
 * Use `create(CancelWorkflowExecutionRequestSchema)` to create a new message.
 */
export const CancelWorkflowExecutionRequestSchema: GenMessage<CancelWorkflowExecutionRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 31);

/**
 * @generated from message chalk.server.v1.CancelWorkflowExecutionResponse
 */
export type CancelWorkflowExecutionResponse = Message<"chalk.server.v1.CancelWorkflowExecutionResponse"> & {
};

/**
 * Describes the message chalk.server.v1.CancelWorkflowExecutionResponse.
 * Use `create(CancelWorkflowExecutionResponseSchema)` to create a new message.
 */
export const CancelWorkflowExecutionResponseSchema: GenMessage<CancelWorkflowExecutionResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 32);

/**
 * @generated from message chalk.server.v1.ListRunningJobsRequest
 */
export type ListRunningJobsRequest = Message<"chalk.server.v1.ListRunningJobsRequest"> & {
  /**
   * @generated from field: repeated string resource_group_names = 1;
   */
  resourceGroupNames: string[];
};

/**
 * Describes the message chalk.server.v1.ListRunningJobsRequest.
 * Use `create(ListRunningJobsRequestSchema)` to create a new message.
 */
export const ListRunningJobsRequestSchema: GenMessage<ListRunningJobsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 33);

/**
 * @generated from message chalk.server.v1.RunningJobInfo
 */
export type RunningJobInfo = Message<"chalk.server.v1.RunningJobInfo"> & {
  /**
   * @generated from field: int32 job_id = 1;
   */
  jobId: number;

  /**
   * @generated from field: string resource_group_name = 2;
   */
  resourceGroupName: string;
};

/**
 * Describes the message chalk.server.v1.RunningJobInfo.
 * Use `create(RunningJobInfoSchema)` to create a new message.
 */
export const RunningJobInfoSchema: GenMessage<RunningJobInfo> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 34);

/**
 * @generated from message chalk.server.v1.ListRunningJobsResponse
 */
export type ListRunningJobsResponse = Message<"chalk.server.v1.ListRunningJobsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.RunningJobInfo running_job_infos = 1;
   */
  runningJobInfos: RunningJobInfo[];
};

/**
 * Describes the message chalk.server.v1.ListRunningJobsResponse.
 * Use `create(ListRunningJobsResponseSchema)` to create a new message.
 */
export const ListRunningJobsResponseSchema: GenMessage<ListRunningJobsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 35);

/**
 * Mirrors the fields of the Go `shared.JobQueueRequest` struct that are serialized into
 * the `job_args` JSON blob stored on a job_queue row.
 *
 * @generated from message chalk.server.v1.JobQueueEnqueueArgs
 */
export type JobQueueEnqueueArgs = Message<"chalk.server.v1.JobQueueEnqueueArgs"> & {
  /**
   * @generated from field: map<string, string> env_payload = 1;
   */
  envPayload: { [key: string]: string };

  /**
   * @generated from field: bool enable_profiling = 2;
   */
  enableProfiling: boolean;

  /**
   * @generated from field: int32 max_attempts = 3;
   */
  maxAttempts: number;

  /**
   * @generated from field: string deployment_id = 4;
   */
  deploymentId: string;

  /**
   * @generated from field: optional string branch_name = 5;
   */
  branchName?: string;

  /**
   * @generated from field: optional string override_source_uri = 6;
   */
  overrideSourceUri?: string;

  /**
   * @generated from field: optional int32 completion_deadline_seconds = 7;
   */
  completionDeadlineSeconds?: number;

  /**
   * @generated from field: bool retry_on_completion_deadline = 8;
   */
  retryOnCompletionDeadline: boolean;

  /**
   * @generated from field: optional int32 operation_completion_deadline_seconds = 9;
   */
  operationCompletionDeadlineSeconds?: number;

  /**
   * @generated from field: bool retry_on_operation_completion_deadline = 10;
   */
  retryOnOperationCompletionDeadline: boolean;
};

/**
 * Describes the message chalk.server.v1.JobQueueEnqueueArgs.
 * Use `create(JobQueueEnqueueArgsSchema)` to create a new message.
 */
export const JobQueueEnqueueArgsSchema: GenMessage<JobQueueEnqueueArgs> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 36);

/**
 * @generated from message chalk.server.v1.EnqueueJobRequest
 */
export type EnqueueJobRequest = Message<"chalk.server.v1.EnqueueJobRequest"> & {
  /**
   * Routing metadata for the row inserted into `job_queue`.
   *
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * @generated from field: chalk.server.v1.JobQueueKind kind = 2;
   */
  kind: JobQueueKind;

  /**
   * @generated from field: string resource_group = 3;
   */
  resourceGroup: string;

  /**
   * @generated from field: string operation_id = 4;
   */
  operationId: string;

  /**
   * If unset, defaults to args.deployment_id.
   *
   * @generated from field: optional string mainline_deployment_id = 5;
   */
  mainlineDeploymentId?: string;

  /**
   * @generated from field: optional string job_name = 6;
   */
  jobName?: string;

  /**
   * @generated from field: optional int32 job_index = 7;
   */
  jobIndex?: number;

  /**
   * @generated from field: optional int32 fetch_priority = 8;
   */
  fetchPriority?: number;

  /**
   * @generated from field: optional string workflow_execution_id = 9;
   */
  workflowExecutionId?: string;

  /**
   * If set > 0 and less than num jobs in operation, used to gate worker
   * concurrency (job starts in WAITING until workers pick it up).
   *
   * @generated from field: optional int32 num_workers = 10;
   */
  numWorkers?: number;

  /**
   * Body payload serialized into `job_args` JSON and consumed by the worker.
   *
   * @generated from field: chalk.server.v1.JobQueueEnqueueArgs args = 20;
   */
  args?: JobQueueEnqueueArgs;
};

/**
 * Describes the message chalk.server.v1.EnqueueJobRequest.
 * Use `create(EnqueueJobRequestSchema)` to create a new message.
 */
export const EnqueueJobRequestSchema: GenMessage<EnqueueJobRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 37);

/**
 * @generated from message chalk.server.v1.EnqueueJobResponse
 */
export type EnqueueJobResponse = Message<"chalk.server.v1.EnqueueJobResponse"> & {
};

/**
 * Describes the message chalk.server.v1.EnqueueJobResponse.
 * Use `create(EnqueueJobResponseSchema)` to create a new message.
 */
export const EnqueueJobResponseSchema: GenMessage<EnqueueJobResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplanejobqueue, 38);

/**
 * @generated from enum chalk.server.v1.JobQueueState
 */
export enum JobQueueState {
  /**
   * @generated from enum value: JOB_QUEUE_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: JOB_QUEUE_STATE_SCHEDULED = 1;
   */
  SCHEDULED = 1,

  /**
   * @generated from enum value: JOB_QUEUE_STATE_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * @generated from enum value: JOB_QUEUE_STATE_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * @generated from enum value: JOB_QUEUE_STATE_FAILED = 4;
   */
  FAILED = 4,

  /**
   * @generated from enum value: JOB_QUEUE_STATE_CANCELED = 5;
   */
  CANCELED = 5,

  /**
   * @generated from enum value: JOB_QUEUE_STATE_NOT_READY = 6;
   */
  NOT_READY = 6,

  /**
   * @generated from enum value: JOB_QUEUE_STATE_WAITING = 7;
   */
  WAITING = 7,
}

/**
 * Describes the enum chalk.server.v1.JobQueueState.
 */
export const JobQueueStateSchema: GenEnum<JobQueueState> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_dataplanejobqueue, 0);

/**
 * in sync with shared/chalkshared/models/metrics/job_queue.py::JobQueueKind
 *
 * @generated from enum chalk.server.v1.JobQueueKind
 */
export enum JobQueueKind {
  /**
   * @generated from enum value: JOB_QUEUE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: JOB_QUEUE_KIND_ASYNC_OFFLINE_QUERY = 1;
   */
  ASYNC_OFFLINE_QUERY = 1,

  /**
   * @generated from enum value: JOB_QUEUE_KIND_SCHEDULED_QUERY = 2;
   */
  SCHEDULED_QUERY = 2,

  /**
   * @generated from enum value: JOB_QUEUE_KIND_SCRIPT_TASK = 3;
   */
  SCRIPT_TASK = 3,

  /**
   * @generated from enum value: JOB_QUEUE_KIND_CHALKSQL_RUN = 4;
   */
  CHALKSQL_RUN = 4,

  /**
   * @generated from enum value: JOB_QUEUE_KIND_DATAFRAME_RUN = 5;
   */
  DATAFRAME_RUN = 5,

  /**
   * @generated from enum value: JOB_QUEUE_KIND_FILL_WIDE_TABLES = 6;
   */
  FILL_WIDE_TABLES = 6,

  /**
   * @generated from enum value: JOB_QUEUE_KIND_COMPACT_WIDE_TABLES = 7;
   */
  COMPACT_WIDE_TABLES = 7,
}

/**
 * Describes the enum chalk.server.v1.JobQueueKind.
 */
export const JobQueueKindSchema: GenEnum<JobQueueKind> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_dataplanejobqueue, 1);

/**
 * @generated from service chalk.server.v1.DataPlaneJobQueueService
 */
export const DataPlaneJobQueueService: GenService<{
  /**
   * @generated from rpc chalk.server.v1.DataPlaneJobQueueService.GetDataPlaneJobQueue
   */
  getDataPlaneJobQueue: {
    methodKind: "unary";
    input: typeof GetDataPlaneJobQueueRequestSchema;
    output: typeof GetDataPlaneJobQueueResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DataPlaneJobQueueService.ListDataPlaneJobQueue
   */
  listDataPlaneJobQueue: {
    methodKind: "unary";
    input: typeof ListDataPlaneJobQueueRequestSchema;
    output: typeof ListDataPlaneJobQueueResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DataPlaneJobQueueService.GetJobQueueAuxiliaryResources
   */
  getJobQueueAuxiliaryResources: {
    methodKind: "unary";
    input: typeof GetJobQueueAuxiliaryResourcesRequestSchema;
    output: typeof GetJobQueueAuxiliaryResourcesResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DataPlaneJobQueueService.GetJobQueueOperationSummary
   */
  getJobQueueOperationSummary: {
    methodKind: "unary";
    input: typeof GetJobQueueOperationSummaryRequestSchema;
    output: typeof GetJobQueueOperationSummaryResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DataPlaneJobQueueService.ListJobQueueAttempts
   */
  listJobQueueAttempts: {
    methodKind: "unary";
    input: typeof ListJobQueueAttemptsRequestSchema;
    output: typeof ListJobQueueAttemptsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DataPlaneJobQueueService.ForceCancelJobQueueJob
   */
  forceCancelJobQueueJob: {
    methodKind: "unary";
    input: typeof ForceCancelJobQueueJobRequestSchema;
    output: typeof ForceCancelJobQueueJobResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DataPlaneJobQueueService.ForceCancelJobQueueJobs
   */
  forceCancelJobQueueJobs: {
    methodKind: "unary";
    input: typeof ForceCancelJobQueueJobsRequestSchema;
    output: typeof ForceCancelJobQueueJobsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DataPlaneJobQueueService.CancelWorkflowExecution
   */
  cancelWorkflowExecution: {
    methodKind: "unary";
    input: typeof CancelWorkflowExecutionRequestSchema;
    output: typeof CancelWorkflowExecutionResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DataPlaneJobQueueService.ExplainOperationProgress
   */
  explainOperationProgress: {
    methodKind: "unary";
    input: typeof ExplainOperationProgressRequestSchema;
    output: typeof ExplainOperationProgressResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DataPlaneJobQueueService.ListJobQueueConsumers
   */
  listJobQueueConsumers: {
    methodKind: "unary";
    input: typeof ListJobQueueConsumersRequestSchema;
    output: typeof ListJobQueueConsumersResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DataPlaneJobQueueService.ListRunningJobs
   */
  listRunningJobs: {
    methodKind: "unary";
    input: typeof ListRunningJobsRequestSchema;
    output: typeof ListRunningJobsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DataPlaneJobQueueService.GetJobQueueConsumerTimeline
   */
  getJobQueueConsumerTimeline: {
    methodKind: "unary";
    input: typeof GetJobQueueConsumerTimelineRequestSchema;
    output: typeof GetJobQueueConsumerTimelineResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_server_v1_dataplanejobqueue, 0);

/**
 * Sibling to DataPlaneJobQueueService for writing (enqueuing) into the job queue.
 * Kept separate from DataPlaneJobQueueService so write-permission scopes can be
 * tightened independently of the read-oriented surface.
 *
 * @generated from service chalk.server.v1.DataPlaneJobEnqueueService
 */
export const DataPlaneJobEnqueueService: GenService<{
  /**
   * @generated from rpc chalk.server.v1.DataPlaneJobEnqueueService.EnqueueJob
   */
  enqueueJob: {
    methodKind: "unary";
    input: typeof EnqueueJobRequestSchema;
    output: typeof EnqueueJobResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_server_v1_dataplanejobqueue, 1);

